import React from 'react';
import LogoIcon from '@/assets/image/logoPreloader.svg?react';
import { useI18n } from '../../hooks/useI18n';

export const FullscreenLoader: React.FC<{ inline?: boolean }> = ({ inline = false }) => {
  const { t } = useI18n();
  return (
    <div className={`cab-fullscreen-loader ${inline ? 'inline' : ''}`}>
      <div className="cab-fullscreen-loader-content">
        {!inline && <LogoIcon className="cab-fullscreen-loader-logo" />}
        <div className="cab-fullscreen-loader-spinner"></div>
        <div className="cab-fullscreen-loader-text">{t('loading_dots') || 'Załadunek...'}</div>
      </div>
      <style>{`
        .cab-fullscreen-loader {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #ffffff;
          z-index: 99999;
        }
        .cab-fullscreen-loader.inline {
          position: relative;
          width: 100%;
          height: 100%;
          min-height: 300px;
          z-index: 1;
        }
        .cab-fullscreen-loader-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 32px;
        }
        .cab-fullscreen-loader-logo {
          height: 32px;
          width: auto;
        }
        .cab-fullscreen-loader-spinner {
          width: 80px;
          height: 80px;
          border: 10px solid #D6C1F1;
          border-top-color: #250953;
          border-right-color: #250953;
          border-radius: 50%;
          animation: cab-spin 1s linear infinite;
        }
        .cab-fullscreen-loader-text {
          font-family: inherit;
          font-size: 18px;
          font-weight: 600;
          color: #D6C1F1;
        }
        @keyframes cab-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @media (max-width: 768px) {
          .cab-fullscreen-loader-logo {
            height: 24px;
          }
          .cab-fullscreen-loader-spinner {
            width: 48px;
            height: 48px;
            border-width: 6px;
          }
        }
      `}</style>
    </div>
  );
};
